import {BackendDeletedUserList} from 'components/Backend/User/DeleteList';

export default BackendDeletedUserList;
